import {
  getResourceInfo,
  getResourceAssignedTasks,
  getQuotasByResource,
  updateQuotasByResource,
  createQuotasByResource,
  deleteQuotasByResource,
  getFleetsByResource,
  getResourceHistoricTasks
} from './resource-profile.services'
import { mapFleetsToColor } from './resource-profile.tools'

const DEFAULT_TASKS_RESULT = { tasks: [], number_of_pages: 0, loading: true }
const DEFAULT_QUOTAS_RESULT = { fleets: [], last_date_quota: null, loading: true }

const ResourceProfileStore = () => ({
  resourceInfo: { loading: true },
  assignedTasks: DEFAULT_TASKS_RESULT,
  resourceQuotas: DEFAULT_QUOTAS_RESULT,
  resourceFleets: [],
  historicTasks: DEFAULT_TASKS_RESULT,
  loadResourceInfo: function* (resourceId) {
    const result = yield getResourceInfo(resourceId)
    this.resourceInfo = { ...result, loading: false }
  },
  loadAssignedTasks: function* (resourceId, limit, offset) {
    const result = yield getResourceAssignedTasks(resourceId, { limit, offset })
    this.assignedTasks = { ...result, loading: false }
  },
  loadQuotas: function* (resourceId, from, to) {
    const result = yield getQuotasByResource(resourceId, { from, to })
    this.resourceQuotas = { ...result, loading: false }
  },
  loadFleets: function* (resourceId) {
    const result = yield getFleetsByResource(resourceId)
    if (result) {
      this.resourceFleets = mapFleetsToColor(result.fleets)
    }
  },
  loadHistoricTasks: function* (resourceId, { limit, offset, from, to, states }) {
    const result = yield getResourceHistoricTasks(resourceId, { limit, offset, from, to, states })
    this.historicTasks = { ...result, loading: false }
  },
  createQuotasByResource: function* (resourceId, fleetId, quotas, from, to) {
    let result = yield createQuotasByResource(fleetId, resourceId, quotas)
    if (!result) {
      return
    }
    this.loadQuotas(resourceId, from, to)
    return result
  },
  updateQuotasByResource: function* (resourceId, from, to, quotas) {
    let result = yield updateQuotasByResource(resourceId, { from, to, quotas })
    if (!result) {
      return
    }
    this.loadQuotas(resourceId, from, to)
    return result
  },
  deleteQuotasByResource: async function (resourceId, fleetsQuotas, from, to) {
    let result = []
    for await (const fleetQuotas of fleetsQuotas) {
      const { fleetId, quotas } = fleetQuotas
      result.push(await deleteQuotasByResource(fleetId, resourceId, quotas))
    }
    if (result.length !== fleetsQuotas.length) {
      return
    }
    this.loadQuotas(resourceId, from, to)
    return result
  },
  cleanAll: function () {
    this.resourceInfo = { loading: true }
    this.assignedTasks = DEFAULT_TASKS_RESULT
    this.resourceQuotas = DEFAULT_QUOTAS_RESULT
    this.resourceFleets = []
    this.historicTasks = DEFAULT_TASKS_RESULT
  }
})

export default ResourceProfileStore
